import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Select2OptionData } from 'ng2-select2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  returnUrl: string;
  loginFailed: boolean;
  routeBase: string;
  isSchool: boolean;

  // Forgot password
  forgotUsername: string = '';
  forgotRole: string = 'ROLE_CLIENT';
  forgotPasswordSent: boolean = false;
  forgotPasswordMessage: string = '';
  forgotPasswordError: string = '';
  forgotPasswordLoading: boolean = false;

  credentials = {
    username: '',
    password: '',
    role: 'ROLE_CLIENT'
  };
  public rolesData: Array<Select2OptionData>;


  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private http: HttpClient
  ) {
    this.loginFailed = false;
    this.routeBase = 'school';
    this.isSchool = false;
  }


  ngOnInit() {
    this.route.data
      .subscribe((data: { isSchool: boolean }) => {
        this.routeBase = data.isSchool ? 'school' : 'pro';
        this.isSchool = data.isSchool;
      });
    const returnUrl = this.route.snapshot.queryParams['returnUrl'];
    this.returnUrl = (returnUrl && returnUrl.indexOf('/login') !== 0 && returnUrl.indexOf('/logout') !== 0) ? returnUrl : '/';
    if (this.authService.isLoggedIn) {
      this.router.navigateByUrl(this.returnUrl);
    }
    this.rolesData = [
      { id: 'ROLE_CLIENT', text: 'Administrateur' },
      { id: 'ROLE_RESPONSIBLE', text: 'Responsable' }
    ];
  }

  roleChanged(e: any) {
    this.credentials.role = e.value;
  }

  onSubmit() {
    if (this.credentials.username && this.credentials.password && this.credentials.role) {
      this.authService.login(this.credentials.username, this.credentials.password, this.credentials.role)
        .subscribe(
          result => {
            this.router.navigateByUrl(this.returnUrl);
          },
          error => {
            this.loginFailed = true;
          }
        );
    }
  }

  submitForgotPassword() {
    this.forgotPasswordError = '';
    this.forgotPasswordLoading = true;
    this.http.post<any>('/api/auth/forgot-password', {
      username: this.forgotUsername,
      role: this.forgotRole
    }).subscribe(
      (res) => {
        this.forgotPasswordLoading = false;
        this.forgotPasswordSent = true;
        this.forgotPasswordMessage = res.message;
      },
      (err) => {
        this.forgotPasswordLoading = false;
        this.forgotPasswordError = (err.error && err.error.message) ? err.error.message : 'Une erreur est survenue.';
      }
    );
  }

  resetForgotForm() {
    this.forgotUsername = '';
    this.forgotRole = 'ROLE_CLIENT';
    this.forgotPasswordSent = false;
    this.forgotPasswordMessage = '';
    this.forgotPasswordError = '';
    this.forgotPasswordLoading = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts